<template>
  <el-dialog 
    v-if="visible"
    v-el-drag-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    append-to-body
    width="62.5%"
    top="8vh"
    center
    >
    <dialog-header
      slot="title"
      :title="$t('public.choseObd')"
      @close="closeDialog"
    />
    <app-search>
      <div slot="content">
        <el-form inline :model="listQuery" label-width="80px">
          <el-form-item :label="$t('public.obdCode')+'：'">
            <el-input v-model="listQuery.barCode" :placeholder="$t('public.obdCode')" clearable />
          </el-form-item>
        </el-form>
      </div>
      <!-- 清空查询按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <el-table
      ref="tableList"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      row-key="terminalId"
      @row-click="clickRow"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
        reserve-selection
      />
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in tableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :min-width="item.width"
        :align="item.position"
        :sortable="item.sortable"
        />
    </el-table>
    <!-- 分页 -->
    <div style="padding:10px 0" :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="headleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button type="primary" @click="submit()">{{ $t('public.define') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { obdUnauthorizedListUrl, addObdUrl } from '@/api/system/company'
import resolve from '@/api/resolve'
export default {
  mixins: [pagingMixin, otherHeight, tableStyle],
  props: {
    visible: Boolean,
    id: String
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.listLoad()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight * 0.4
    })
    window.onresize = ()=> {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight * 0.4
      })
    }
  },
  data() {
    return {
      listQuery: {
        barCode: ''
      },
      tableList: [
        { value: this.$t('public.obdCode'), prop: 'barCode', position: 'center' },
        { value: this.$t('public.terminal'), prop: 'terminalCode', position: 'center' },
        { value: this.$t('public.expirationTime'), prop: 'expireTime', position: 'center' }
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      multipleSelection: []
    }
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      // this.restData()
      this.$emit('update:visible', false)
    },
    // 点击取消
    headleCancel() {
      this.closeDialog()
    },
    listLoad() {
      if (!this.visible) {
        return
      }
      this.listLoading = true
      this.$http.post(resolve(obdUnauthorizedListUrl, this.id), this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
        }
      }).finally(()=>{
        this.listLoading = false
      })
    },
    clickRow(row) {
      this.$refs.tableList.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    checkSelection () {
      if (this.multipleSelection.length < 1) {
        this.$alert( this.$t('public.createTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return false
      }
      return true
    },
    submit() {
      if (!this.checkSelection()) {
        return
      }
      this.$http.post(resolve(addObdUrl, this.id), this.multipleSelection.map(row => row.terminalId))
      .then(({ data }) => {
        if (data.code == 0) {
          this.$emit('refresh')
          this.closeDialog()
        }
      })
    }
  }
}
</script>
